import React from 'react'
import styled from 'styled-components'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'

const ConflictResolutionPanel = ({ conflicts }) => {
  if (!conflicts || conflicts.length === 0) return null

  return (
    <Panel>
      <PanelHeader>
        <HeaderIcon>
          <WarningAmberIcon />
        </HeaderIcon>
        <HeaderContent>
          <HeaderTitle>
            {conflicts.length} field{conflicts.length !== 1 ? 's differ' : ' differs'} from current Building Passport data
          </HeaderTitle>
          <HeaderSubtitle>
            The following auto-populated fields were changed by the form filler or the Building Passport data has since been updated.
          </HeaderSubtitle>
        </HeaderContent>
      </PanelHeader>

      <ConflictList>
        {conflicts.map(conflict => (
          <ConflictRow key={conflict.fieldKey}>
            <FieldLabel>{conflict.fieldLabel}</FieldLabel>
            <ValueComparison>
              <ValueBox $type="form">
                <ValueLabel>Form Value</ValueLabel>
                <ValueContent>{formatValue(conflict.formValue)}</ValueContent>
              </ValueBox>
              <SwapIcon>
                <SwapHorizIcon />
              </SwapIcon>
              <ValueBox $type="bp">
                <ValueLabel>Current Building Passport Value</ValueLabel>
                <ValueContent>{formatValue(conflict.bpValue)}</ValueContent>
              </ValueBox>
            </ValueComparison>
          </ConflictRow>
        ))}
      </ConflictList>
    </Panel>
  )
}

const formatValue = (value) => {
  if (value === null || value === undefined) return '(empty)'
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  if (Array.isArray(value)) return value.join(', ') || '(empty)'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value) || '(empty)'
}

export default ConflictResolutionPanel

// --- Styled Components ---

const Panel = styled.div`
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 12px;
  overflow: hidden;
`

const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  background: #fef3c7;
`

const HeaderIcon = styled.div`
  color: #d97706;
  flex-shrink: 0;
  margin-top: 2px;

  svg { font-size: 24px; }
`

const HeaderContent = styled.div`
  flex: 1;
  min-width: 0;
`

const HeaderTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #92400e;
`

const HeaderSubtitle = styled.div`
  font-size: 12px;
  color: #d97706;
  margin-top: 2px;
`

const ConflictList = styled.div`
  padding: 12px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const ConflictRow = styled.div`
  padding: 12px 16px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
`

const FieldLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
`

const ValueComparison = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`

const ValueBox = styled.div`
  flex: 1;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${({ $type }) => $type === 'form' ? '#f0fdf4' : '#e6f7f9'};
  border: 1px solid ${({ $type }) => $type === 'form' ? '#bbf7d0' : '#bfdbfe'};
  min-width: 0;
`

const ValueLabel = styled.div`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
  margin-bottom: 2px;
`

const ValueContent = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  word-break: break-word;
`

const SwapIcon = styled.div`
  color: #9ca3af;
  flex-shrink: 0;

  svg { font-size: 20px; }
`
